import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Landing } from "components/dashboards/Landing/Landing";
import AccountDeletion from "components/echo-trace/AccountDeletion";
import { PrivacySecurity, Support } from "components/orbit-up/OrbitUpPage";
import {
  EightfoldPrivacyPolicy,
  EightfoldSupport,
} from "components/eightfold/EightfoldPage";

const NodraRoutes = () => (
  <Routes>
    <Route path="/" element={<Landing />} />
    <Route
      path="/echo-trace/account-deletion"
      element={<AccountDeletion />}
    />
    <Route path="/orbit-up/privacy-security" element={<PrivacySecurity />} />
    <Route path="/orbit-up/support" element={<Support />} />
    <Route path="/eightfold/privacy-policy" element={<EightfoldPrivacyPolicy />} />
    <Route path="/eightfold/support" element={<EightfoldSupport />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default NodraRoutes;
